<div class="orcaa-wrapper">

    <!-- HEADER -->
    <h2 class="fw-bold gradient-text">Proba Analytics</h2>
    <p class="text-muted mb-4">
      Upload data, generate dashboards, and automate reports with powerful analytics tools built for decision-making.
    </p>

    <!-- TOP METRIC CARDS -->
    <div class="row g-3 mb-3">

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-primary">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Processing</span>
                        <i class="fa-solid fa-magic text-primary"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Real-time</div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-success">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Models</span>
                        <i class="fa-solid fa-refresh text-success"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Predictive</div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Dashboards</span>
                        <i class="fa-solid fa-line-chart gradient-text"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Custom</div>
                </div>
            </div>
        </div>

       <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-warning">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Reports</span>
                        <i class="fa-solid fa-suitcase text-warning"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Automated</div>
                </div>
            </div>
        </div>

    </div>

    <!-- FEATURE CARDS (PERFECT 2×2 GRID) -->
    <div class="row g-4">

      <!-- CARD 1 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-table gradient-text"></i>
            </div>
            <h5 class="fw-bold">Upload Data → Get Instant Analysis</h5>
          </div>

          <p class="text-muted feature-body">
            Upload CSV, Excel, or system data.
            Proba Analytics automatically structures, validates, and analyzes your data for insights.
          </p>

          <button class="btn upload-button w-100" @click="launch_workspace('file')">
            <i class="bi bi-upload me-2"></i>Upload Data
          </button>

        </div>
      </div>

      <!-- CARD 2 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-commenting gradient-text"></i>
            </div>
            <h5 class="fw-bold">Build Custom Dashboards</h5>
          </div>

          <div class="feature-body">
            <p class="text-muted">
              Create interactive dashboards with your own KPIs, charts, and segmentation.
              Perfect for executives and operational teams.
            </p>

          </div>

          <button class="btn upload-button w-100 mt-3" @click="launch_workspace('dashboard')">
            Build Dashboard
          </button>

        </div>
      </div>

      <!-- CARD 3 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-book gradient-text"></i>
            </div>
            <h5 class="fw-bold">Advanced Data Analysis</h5>
          </div>

          <p class="text-muted feature-body">
            Identify trends, risks, opportunities, and performance gaps using AI-powered analytics tools.
          </p>

          <button class="btn upload-button w-100" @click="launch_workspace('analysis')">
            <i class="bi bi-upload me-2"></i>Analyze Data
          </button>

        </div>
      </div>

      <!-- CARD 4 -->
      <div class="col-md-6 d-none">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-bar-chart gradient-text"></i>
            </div>
            <h5 class="fw-bold">Automated Reporting</h5>
          </div>

          <p class="text-muted feature-body">
            Generate reports instantly or schedule recurring reports with automated email delivery to stakeholders.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Generate Report
          </button>

        </div>
      </div>


    </div>

  </div>